export default __webpack_public_path__ + "static/media/dna_loader.4c4bb697.svg";